import React from 'react';

const StatsSection = () => {
  const stats = [
    { num: '10,000+', label: '旅行日记' },
    { num: '500+', label: '精选目的地' },
    { num: '8', label: '场景模板' },
    { num: '50万+', label: '旅人足迹' },
  ];

  return (
    <section className="py-20">
      <div className="max-w-5xl mx-auto px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {stats.map((s, i) => (
            <div key={i} className="frost p-5 text-center">
              <div className="text-3xl font-bold cb mb-0.5">{s.num}</div>
              <div className="text-[12px] cd">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
